import { LocationEnum } from '../types/location.enum';
import { BookingLocation } from '../types/booking-location.type';
import { EquipmentEnum } from '../types/equipment.enum';
import { VisitCardMap as LanaiVisitCards } from './location/lanai/visit-card.map';
import { VisitCardMap as PorcupineCreekVisitCards } from './location/porcupine-creek/visit-card.map';
import { covidPolicy as LanaiCovidPolicy } from './location/lanai/covid-policy';
import { covidPolicy as PorcupineCreekCovidPolicy } from './location/porcupine-creek/covid-policy';
import { ExperiencesTabs as LanaiExperiencesTabs } from './location/lanai/experiences';
import { ExperiencesTabs as PorcupineCreekExperiencesTabs } from './location/porcupine-creek/experiences';

export const Locations: BookingLocation[] = [
    {
        propertyId: '1',
        key: 'lanai',
        timezone: 'Pacific/Honolulu',
        stateCode: 'HI',
        name: LocationEnum.LANAI,
        covid: LanaiCovidPolicy,
        reservationUrl: 'https://sensei.com/retreats/lanai/',
        contact: {
            experiencesEmail: 'experiences-lanai@sensei.com',
            reservationsEmail: 'reservations@sensei.com',
            preArrivalSpecialistsPhone: '+1 (855) 961-0077',
        },
        packingList: {
            image: 'packing-list-dialog-lanai.jpg',
            pdf: 'packing-list-lanai.pdf',
            equipments: [
                EquipmentEnum.ATHLETIC_ATTIRE,
                EquipmentEnum.WIND_PROTECTING_LAYER,
                EquipmentEnum.LEISURE_WEAR,
                EquipmentEnum.SMALL_BACKBACK,
                EquipmentEnum.TREKKING_SHOES,
                EquipmentEnum.SWIMSUIT,
                EquipmentEnum.SUN_PROTECTION_GEAR,
            ],
        },
        visit: {
            coverImage: 'visits-lanai.png',
            cards: LanaiVisitCards,
        },
        experiences: LanaiExperiencesTabs,
        propertyMap: {
            pdf: 'property-map-lanai.pdf',
            image: 'property-map-lanai.png',
        },
        activityCalendar: {
            headerBackground: 'activity-calendar-background.png',
        },
        activity: {
            meditation: [
                'Meditation_1_660x440.jpg',
                'Meditation_2_660x440.jpg',
                'Meditation_3_660x440.jpg',
                'Meditation_4_660x440.jpg',
                'Meditation_5_660x440.jpg',
            ],
            strength: [
                'Strength_1_660x440.jpg',
                'Strength_2_660x440.jpg',
                'Strength_3_660x440.jpg',
                'Strength_4_660x440.jpg',
            ],
            strengthFlex: [
                'StrengthFlex_1_660x440.jpg',
                'StrengthFlex_2_660x440.jpg',
                'StrengthFlex_3_660x440.jpg',
                'StrengthFlex_4_660x440.jpg',
                'StrengthFlex_5_660x440.jpg',
            ],
            trails: [
                'Trails_1_660x440.jpg',
                'Trails_2_660x440.jpg',
                'Trails_3_660x440.jpg',
                'Trails_4_660x440.jpg',
            ],
            yoga: [
                'Yoga_1_660x440.jpg',
                'Yoga_2_660x440.jpg',
                'Yoga_3_660x440.jpg',
                'Yoga_4_660x440.jpg',
                'Yoga_5_660x440.jpg',
            ],
        },
    },
    {
        propertyId: '2',
        key: 'porcupine-creek',
        name: LocationEnum.PORCUPINE_CREEK,
        timezone: 'America/Los_Angeles',
        stateCode: 'CA',
        covid: PorcupineCreekCovidPolicy,
        reservationUrl: 'https://sensei.com/retreats/porcupine-creek/',
        contact: {
            experiencesEmail: 'Experience.PorcupineCreek@sensei.com',
            reservationsEmail: 'needsupdating_reservations@sensei.com',
            preArrivalSpecialistsPhone: '+1 (855) 961-0077',
        },
        packingList: {
            image: 'packing-list-dialog-porcupine-creek.jpg',
            pdf: 'packing-list-porcupine-creek.pdf',
            equipments: [
                EquipmentEnum.ATHLETIC_ATTIRE_AND_SHOES,
                EquipmentEnum.WIND_PROTECTING_LAYER,
                EquipmentEnum.LIGHT_SWEATER_OR_FLEECE,
                EquipmentEnum.LEISURE_WEAR,
                EquipmentEnum.SMALL_BACKBACK,
                EquipmentEnum.TREKKING_SHOES,
                EquipmentEnum.SWIMSUIT,
                EquipmentEnum.SUN_PROTECTION_GEAR,
            ],
        },
        visit: {
            coverImage: 'visits-porcupine-creek.png',
            cards: PorcupineCreekVisitCards,
        },
        experiences: PorcupineCreekExperiencesTabs,
        propertyMap: {
            pdf: 'property-map-porcupine-creek.pdf',
            image: 'property-map-porcupine-creek.png',
        },
        activityCalendar: {
            headerBackground: 'activity-calendar-background.png',
        },
        activity: {
            meditation: [
                'Meditation_1_660x440.jpg',
                'Meditation_2_660x440.jpg',
                'Meditation_3_660x440.jpg',
                'Meditation_4_660x440.jpg',
                'Meditation_5_660x440.jpg',
            ],
            strength: [
                'Strength_1_660x440.jpg',
                'Strength_2_660x440.jpg',
                'Strength_3_660x440.jpg',
                'Strength_4_660x440.jpg',
            ],
            strengthFlex: [
                'StrengthFlex_1_660x440.jpg',
                'StrengthFlex_2_660x440.jpg',
                'StrengthFlex_3_660x440.jpg',
                'StrengthFlex_4_660x440.jpg',
                'StrengthFlex_5_660x440.jpg',
            ],
            trails: [
                'Trails_1_660x440.jpg',
                'Trails_2_660x440.jpg',
                'Trails_3_660x440.jpg',
                'Trails_4_660x440.jpg',
            ],
            yoga: [
                'Yoga_1_660x440.jpg',
                'Yoga_2_660x440.jpg',
                'Yoga_3_660x440.jpg',
                'Yoga_4_660x440.jpg',
                'Yoga_5_660x440.jpg',
            ],
        },
    },
];
